export const ACTIONS_ORGANIZATIONS = {
	ORGANIZATION: 'organization',
	ORGANIZATION_CREATE: 'organization_create',
	ORGANIZATION_EDIT: 'organization_edit',
	ORGANIZATION_DELETE: 'organization_delete',
} as const;
